"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformRESTFloatToSDKFloat = exports.transformSDKFloatToRESTFloat = void 0;
function transformSDKFloatToRESTFloat(val) {
    return isFinite(val) ? val : val.toString();
}
exports.transformSDKFloatToRESTFloat = transformSDKFloatToRESTFloat;
function transformRESTFloatToSDKFloat(val) {
    if (val === 'NaN') {
        return NaN;
    }
    if (val === 'Infinity') {
        return Infinity;
    }
    if (val === '-Infinity') {
        return -Infinity;
    }
    return val;
}
exports.transformRESTFloatToSDKFloat = transformRESTFloatToSDKFloat;
